export enum ConferencesStatuses {
  /**
   * В работе
   */
  IN_PROGRESS = 'in_progress',

  /**
   * Возвращено на доработку
   */
  RETURNED_FOR_REVISION = 'returned_revision',

  /**
   * Отправлен АТОЛ
   */
  SENT_ATOL = 'sent_atol',

  /**
   * Отмена
   */
  CANCELED = 'canceled',

  /**
   * Закрыто
   */
  CLOSED = 'closed',

  /**
   * Оплачена
   */
  PAID = 'paid',
}

export enum ConferencesTypes {
  FREE = 'free',
  PAID = 'paid',
}

export const ConferencesStatusesTranslate: Record<string, string> = {
  [ConferencesStatuses.IN_PROGRESS]: 'В работе',
  [ConferencesStatuses.RETURNED_FOR_REVISION]: 'Возвращено на доработку',
  [ConferencesStatuses.SENT_ATOL]: 'Отправлен АТОЛ',
  [ConferencesStatuses.CANCELED]: 'Отмена',
  [ConferencesStatuses.CLOSED]: 'Закрыто',
  [ConferencesStatuses.PAID]: 'Оплачена',
};

export const conferences_statuses = Object.keys(ConferencesStatusesTranslate).map((f: string) => ({
  text: ConferencesStatusesTranslate[f],
  value: f,
}));
